import React from "react";
import {MuiIcon, MuiIconProps} from "./MuiIcon";


export const BackIcon = (props: Omit<MuiIconProps, 'code'>) => {
    return (
        <MuiIcon {...props}
        >{'\ue5c4'}</MuiIcon>
    );
}
